import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgDataTableComponent, ExgModalService, ExgPopupComponent} from 'exc-controls-v2';
import {ExgTabV2Component, ExgTabV2ComponentHeaderElement} from '../misc/exg-tab-v2/exg-tab-v2.component';
import {ExgFilterComponent} from '../misc/exg-filter/exg-filter.component';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {EnumerationService} from '../services/enumeration.service';
import {ExgApplicationTabService} from 'exc-tab-v2';
import {ApplicationService} from '../services/application.service';
import {BehaviorSubject} from 'rxjs';
import {ExcSecurityService} from 'exc-security-v2';

@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styles: [
  ]
})
export class CompanyListComponent extends ExcTranslation implements OnInit, AfterViewInit {
  /****************************/
  @ViewChild('VCrightTabControl', {read: ExgTabV2Component}) VCrightTabControl!: ExgTabV2Component;
  @ViewChild('VCcompanyTable', {read: ExgDataTableComponent}) VCcompanyTable!: ExgDataTableComponent;
  @ViewChild('VCcompanyreceiptTable', {read: ExgDataTableComponent}) VCcompanyreceiptTable!: ExgDataTableComponent;
  @ViewChild('VCcompanyTableFilterPopup', {read: ExgPopupComponent}) VCcompanyTableFilterPopup!: ExgPopupComponent;
  @ViewChild('VCcompanyTableSortPopup', {read: ExgPopupComponent}) VCcompanyTableSortPopup!: ExgPopupComponent;
  @ViewChild('VCcompanyTableSearchPopup', {read: ExgPopupComponent}) VCcompanyTableSearchPopup!: ExgPopupComponent;
  @ViewChild('VCcompanyTableFilterControl', {read: ExgFilterComponent}) VCcompanyTableFilterControl!: ExgFilterComponent;
  /****************************/
  rightDrawerVisible = false;
  init = false;
  companyTable = {
    selectKey: 'compID',
    state: 1,
    prefilter_type: 100,
    selectedRow: undefined as any,
    prefilter_DEL: 0,
    searchValue: '',
    uiFilter: [],
    uiSort: [
      {sortField: 'compCRD', sortDefault: 0, uiCaption: 'letzte Erstellung',
        uiValue: false},
      {sortField: 'compLCD', sortDefault: 0, uiCaption: 'letzte Änderung',
        uiValue: true}],
    data: [] as any [],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter
    } as IExcMetaInfo,
    paging: {pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0},
    isLoading: true,
    selectionChanged: (index: any) => {
      this.companyTable.selectedRow = this.companyTable.data[index];
      this.loadCompanySummary();
    },
    pageChanged: (page: number) => {
      if (this.companyTable.MetaInfo.dataPaging !== undefined) {
        this.companyTable.MetaInfo.dataPaging.pageNo = page;
      }
      this.loadCompanyData();
    },
    search: (value: string) => {
      this.companyTable.searchValue = value;
      this.companyTable.pageChanged(0);
      this.loadCompanyData();
    },
    ready: () => {
      if (this.companyTable.data.length === 0) {
        this.companyTable.state = 2;
        this.VCcompanyTable.selectedRow = -1;
      }  else {
        this.companyTable.state = 0;
        this.VCcompanyTable.selectedRow = 0;
      }
      this.companyTable.isLoading = false;
      this.tableIsLoading.next(this.companyTable.isLoading);
    },
    loadData: (incomingData: any, incomingPaging: any) => {
      this.companyTable.isLoading = false;
      this.companyTable.data = incomingData;
      this.companyTable.paging = incomingPaging;
      this.companyTable.ready();
    },
    isFiltered: (): boolean => {
      return (this.companyTable.uiFilter && JSON.stringify({}) !== JSON.stringify(this.companyTable.MetaInfo.dataFilter));
    }
  };

  rightTabs: ExgTabV2ComponentHeaderElement[] = [];
  companyTableDrawer = {
    company: undefined as any,
    receipts:  [],
    isLoading: false,
    selectKey: 'rcptID',
    state: 1,
    selectedRow: undefined as any,


    loadData: (entity: any, receipts: any) => {
      this.companyTableDrawer.company = entity;
      this.companyTableDrawer.receipts = receipts;
    },
    selectionChanged: ($event: number) => {
      this.companyTableDrawer.selectedRow = this.companyTableDrawer.receipts[$event];
    },
    ready: () => {
      if (this.companyTableDrawer.receipts.length === 0) {
        this.companyTableDrawer.state = 2;
        this.VCcompanyreceiptTable.selectedRow = -1;
      }  else {
        this.companyTableDrawer.state = 0;
        this.VCcompanyreceiptTable.selectedRow = 0;
      }
      this.companyTableDrawer.isLoading = false;
      this.tableDrawerIsLoading.next(this.companyTableDrawer.isLoading);
    }
  };
  tableIsLoading = new BehaviorSubject(this.companyTable.isLoading);
  tableDrawerIsLoading = new BehaviorSubject(this.companyTableDrawer.isLoading);

  constructor(
    private chDecRef: ChangeDetectorRef,
    private excRestService: ExcRestService,
    private modalService: ExgModalService,
    private exgApplicationTabService: ExgApplicationTabService,
    private appSvc: ApplicationService,
    public enumSvc: EnumerationService,
    public excSecurity: ExcSecurityService) {
    super();
  }

  /* Lifecycle Hooks*/
  ngOnInit(): void {
    this.initialize();
  }

  ngAfterViewInit(): void {
    this.VCcompanyTableFilterControl.ApplyFilter();
    this.registerEvents();
  }

  registerEvents(): void {
    ExcCoreModule.Services().StrgI.subscribe(() => {
      if (this.exgApplicationTabService.StateTab?.Active) {
        this.rightDrawerVisible = !this.rightDrawerVisible;
      }
    });
    ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
      this.loadCompanyData();
    });
    this.tableIsLoading.subscribe(async (value) => {
      this.chDecRef.reattach();
      if (!value) {
        await new Promise(f => setTimeout(f, 1000));
        this.chDecRef.detach();
      }
    });
    this.tableDrawerIsLoading.subscribe(async (value) => {
      this.chDecRef.reattach();
      if (!value) {
        await new Promise(f => setTimeout(f, 1000));
        this.chDecRef.detach();
      }
    });
  }

  initialize(): void {
    const SELF = this;
    SELF.loadCompanyData();
    SELF.rightTabs = [
      {
        get caption(): string {
          return SELF.getGlobal('Details');
        },
        icon_class: SELF.getRessource('Icon')
      },
      {
        get caption(): string {
          return SELF.getRessource('Receipts');
        },
        icon_class: SELF.getRessource('ReceiptIcon')
      }
    ];
  }

  loadCompanyData(): void {
    const SELF = this;
    SELF.companyTable.state = 1;
    SELF.companyTable.isLoading = true;
    this.tableIsLoading.next(this.companyTable.isLoading);
    SELF.excRestService
      .get(
        SELF.excRestService.computeUrl('CompanyR_List', {
          fts: this.companyTable?.searchValue
        }), {MetaInfo: SELF.companyTable.MetaInfo})
      .subscribe(
        (data: any) => {
          if (data.success) {
            SELF.companyTable.loadData(data.data, data.paging);
          }
        }
      ).add(() => {
        this.companyTable.ready();
      });
  }

  loadCompanySummary(): void {
    const SELF = this;
    if (this.companyTable.data.length > 0 && this.companyTable.selectedRow) {
      SELF.companyTableDrawer.isLoading = true;
      this.tableDrawerIsLoading.next(this.companyTableDrawer.isLoading);
      SELF.excRestService
        .get(
          SELF.excRestService.computeUrl('CompanyGROOT', {compID: this.companyTable.selectedRow?.compID})
          , {})
        .subscribe((data: any) => {
            if (data.success) {
              SELF.companyTableDrawer.loadData(data.data.Company, data.data.Receipt);
            }
            SELF.companyTableDrawer.ready();
          }
        ).add(() => {
          this.companyTableDrawer.ready();
        });
    }
  }

  togglePopupMenu(e: any, context: any, pos: string = 'underleft'): void {
    if (context) {
      if (context.visibility === 'hidden') {
        switch (pos) {
          case 'underleft': {
            context.openUnderLeft(e);
            break;
          }
          case 'abovecenter': {
            context.openAboveCenter(e);
            break;
          }
        }
      } else {
        context.close();
      }
    }
  }

  closePopupMenuAndReload(): void {
    this.VCcompanyTableFilterPopup.close();
    this.VCcompanyTableSortPopup.close();
    this.VCcompanyTableSearchPopup.close();
    this.loadCompanyData();
  }



  rightTabs_tabChange($event: number): void {
    switch ($event) {
      case 1:
        this.companyTableDrawer.ready();
        break;
      default:
        break;
    }
  }
  get tableLoading(): boolean {
    return (this.companyTable.isLoading);
  }
  get tableEmpty(): boolean {
    return (this.companyTable.state === 2);
  }

  toggleRightDrawer(): void {
    this.chDecRef.reattach();
    this.rightDrawerVisible = !this.rightDrawerVisible;
    this.tableDrawerIsLoading.next(false);
  }

  change($event: { index: number; value: any }): void  {
    this.loadCompanyData();
  }

  openCheckView(rcptID?: string): void {
    if (!rcptID) {
      rcptID = this.companyTableDrawer.selectedRow[this.companyTableDrawer.selectKey];
    }
    if (rcptID && !this.tableEmpty) {
      this.appSvc.Receipt.Checkview.OpenTab(rcptID);
    } else {
      this.modalService
        .showToast(this.getRessource('NoReceiptFound')
          , 'md-toast bg-red'
          , this.getRessource('ReceiptIcon'));
    }
  }

  openWorkspace(): void {
    if (this.companyTableDrawer?.selectedRow && this.companyTableDrawer.selectedRow?.rcpt_vorgID && !this.tableEmpty) {
      this.appSvc.Task.Workspace.OpenTabV2(this.companyTableDrawer.selectedRow.rcpt_vorgID);
    } else {
      this.modalService
        .showToast(this.getRessource('NoTaskFound')
          , 'md-toast bg-red'
          , this.getRessource('TaskIcon'));
    }
  }

  getAdresslines(row: any): string {
    return (row.compAdressline1 ? row.compAdressline1 + ' ' : '')
    + (row.compAdressline2 ? row.compAdressline2 + ' ' : '')
    + (row.compAdressline3 ? row.compAdressline3 + ' ' : '')
    + (row.compAdressline4 ? row.compAdressline4 : '');
  }

  isNumberString(value: unknown): boolean {
    if (!value) {
      return false;
    }
    const s = String(value).trim();

    // erlaubt:  "12", "-12", "12.3", "12,3"
    // nicht erlaubt: "", "12a", "1 2"
    return s !== '' && !Number.isNaN(Number(s.replace(',', '.')));
  }
}
